import { RedirectCommand, Router, Routes, UrlMatcher } from '@angular/router';
import { FRAME_OF_REFERENCE_ROUTES } from '@features/frame-of-reference/frame-of-reference.routes';
import { HomeComponent } from '@features/home/home.component';
import { scenariosBrowseRoutes } from '@features/scenarios-browse/scenarios-browse.routes';
import { scenariosManageRoutes } from '@features/scenarios-manage/scenarios-manage.routes';

import { PageNotFoundComponent, PageNotFoundState } from '@shared/components/page-not-found/page-not-found.component';
import { inject } from '@angular/core';
import { catchError, of } from 'rxjs';
import { UserDocsComponent } from '@features/documentation/documentation.component';
import { authGuard } from '@core/guards/auth.guard';

/** Custom URL matcher to use in a child route that matches all path except empty path ''. */
export const childNotFoundUrlMatcher: UrlMatcher = (url) => (url.length > 0 ? { consumed: url } : null);

/** Catch error in an observable and map the result to a RedirectCommand, meant to be used in a resolver pipe. */
export const redirectOnFail = (toPath: string, entityTranslationKey?: string) => {
  const router = inject(Router);
  return catchError(() => {
    const url = router.parseUrl(toPath);
    const state: PageNotFoundState = { entityTranslationKey: entityTranslationKey };
    const redirect = new RedirectCommand(url, { skipLocationChange: true, state: state });
    return of(redirect);
  });
};

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard],
  },
  ...FRAME_OF_REFERENCE_ROUTES,
  {
    path: 'scenarios',
    children: [
      {
        path: '',
        redirectTo: 'browse',
        pathMatch: 'full',
      },
      {
        path: '',
        redirectTo: 'manage',
        pathMatch: 'full',
      },
      ...scenariosBrowseRoutes,
      ...scenariosManageRoutes,
    ],
  },
  {
    path: 'documentation/:doc',
    component: UserDocsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'personal-data-protection-notice/notice/english',
    loadComponent: () =>
      import('@features/documentation/personal-data-protection-notice/notice.component').then((m) => m.NoticeComponent),
    canActivate: [authGuard],
  },
  {
    path: 'personal-data-protection-notice/notice/french',
    loadComponent: () =>
      import('@features/documentation/personal-data-protection-notice/notice-french.component').then(
        (m) => m.NoticeFrenchComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'forbidden',
    loadComponent: () =>
      import('./shared/components/maintenance/maintenance.component').then((m) => m.MaintenanceComponent),
  },

  // Keep this route at the end.
  { path: '**', component: PageNotFoundComponent },
];
